import {createSelector} from 'reselect'

const getItems = (stateSelector) => createSelector(
  stateSelector,
  (items) => items.order ? items.order.map(_=>items[_]) : []
)

export const getReports = getItems(state=> state.reports)

export const getWorkstations = getItems(state=> state.workstations)



// WEBPACK FOOTER //
// ./src/javascripts/selectors/index.js